/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
  07.21.Wizards
*/

module.exports = {
  /* 01.General */
  "general.copyright": "Gogo React © 2018 All Rights Reserved.",
  "files.name": "Files",
  /* 02.User Login, Logout, Register */
  "user.login-title": "Login",
  "menu.files": "Files",
  "user.register": "Register",
  "user.forgot-password": "Forgot Password",
  "user.preferences":"Preferences",
  "user.email": "E-mail",
  "user.password": "Password",
  "user.forgot-password-question": "Forget password?",
  "user.fullname": "Full Name",
  "user.login-button": "LOGIN",
  "user.register-button": "REGISTER",
  "user.reset-password-button": "RESET",
  "user.buy": "BUY",
  "user.username": "Username",
  "user.new-password-again": "New Password Again",
  "user.new-password": "New Password",
  "user.reset-password": "Reset Password",
  "menu.all-notifications": "All Notifications",
  "menu.notifications": "Notifications",
  "createUser": "Create User",
  "updateUser": "Update User",
  "email": "Email",
  "dob": "Date Of Birth",
  "password": "Password",
  "confirmPassword": "Confirm Password",
  "edit": "Edit",
  "delete": "Delete",
  "create": "Create",
  "view": "View",
  "update": "Update",
  "cancel": "cancel",
  "name":"Name",
  "updateProfile":"Update Profile",
  "profile": "Profile",
  "oldPassword": "Old Password",
  "phone":"Phone",
  "menu.create": "Create",
  "menu.view": "View",
  "menu.cancel": "Cancel",
   "menu.edit": "Edit",
  "menu.signals": "Vip Signals",
  "menu.vip-signals": "Vip Signals",
  "createSignal": "Create VIP Signal",
  "updateSignal": "Update VIP Signal",
  "signals": "VIP Signals",
  "title": "Title",
  "subtitle": "Subtitle",
  "menu.video": "Videos",
  "menu.upload": "Upload",
  "entryPoint": "Entry Point",
  "openedDateAndTime": "Opened Date & Time",
  "listOfTrades": "List Of Trades",
  "rows": "Rows",
  "point": "Point",
  "heading": "Heading",
  "total": "Total",
  "backgroundColor": "Background Color",
  "textColor": "Text Color",
  "checkMarkIcon": "Check Mark Icon",
  "detailText": "Detail Text",
  "closed-Opened": "Closed/Opened",
  "addNew": "Add New",
  "menu.result": "Results",
  "menu.translations": "Translations",
  "menu.results": "Results",
  "createResult": "Create Result",
  "updateResult": "Update Result",
  "result": "Results",
  "results": "Results",
  "position": "Position",
  "action": "Action",
  "active": "Active",
  "menu.vip-registration": "VIP Registration",
  "menu.vip-registrations": "VIP Registrations",
  "vipRegistration": "VIP Registrations",
  "waitingRegistration": "Waiting Registrations",
  //Categories
  "categories": "Categories",
  "category.delete": "Delete",
  "category.edit": "Edit",
  "category.update": "Update Category",
  "categories-type": "Type",
  "menu.categoriesSub":"Sub Categories",
  "menu.subCategories":"Sub Categories",
  //Guides
  "menu.province":"Province",
  "menu.city":"City",
  "city.create":"Create City",
  "guide.injured":"Injured",
  "menu.guides": "Guides",
  "guides.create": "Create",
  "guide.killed":"Killed",
  "guide.arrested":"Arrested",
  "guide.protestor":"Protestor",
  "guide.location":"Location",
  "support.view":"Support",
  "guides.create-guide": "Create Guide",
  "guides.update": "Update",
  "guides.update-guide": "Update Guide",
  "guides.edit": "Edit",
  "role.provinces":"Select Province",
  "guides.view-guide": "Guides",
  "guides.view": "View",
  "guides.delete": "Delete",
  "guide.title": "Title",
  "guide.category": "Category",
  "guide.row": "Row",
  "guide.add-rows": "Add Row",
  //Settings
  "menu.privacy-policy": 'Privacy Policy',
  "menu.terms": "Term & Conditions",
  "menu.terms-and-conditions": "Term & Conditions",
  "save": "save",
  "menu.security": "Security",
  //FAQS
  "menu.faqs":"FAQs",
  "faq.faqs": "Frequently Asked Questions",
  "faq.view": "View",
  "faq.create": "Create",
  "faq.create-faq": "Create FAQ",
  "faq.question": "Question",
  "faq.answer": "Answer",
  "faq.edit": "Edit",
  "faq.update": "Update",
  "faq.update-faq": "Update FAQ",
  //Partners
  "menu.partners":"Partners",
  "partner.partners": "Partners",
  "partner.view": "View",
  "partner.create": "Create",
  "partner.create-partner": "Create Partner",
  "partner.name": "Name",
  "partner.logo": "Logo",
  "partner.edit": "Edit",
  "partner.update": "Update",
  "partner.update-partner": "Update Partner",
  //Contact Us
  "menu.contact": "Contact",
  "contact.view": "View",
  "contact.contact-us": "Contact us",
  /* 03.Menu */
  "menu.app": "Home",
  "menu.dashboards": "Dashboard",
  "menu.dashboard": "Dashboard",
  "menu.default": "Default",
  "menu.analytics": "Analytics",
  "menu.ecommerce": "Ecommerce",
  "menu.content": "Content",
  "user.name": "Name",
  "menu.pages": "Pages",
  "menu.data-list": "Data List",
  "menu.thumb-list": "Thumb List",
  "menu.image-list": "Image List",
  "menu.details": "Details",
  "menu.search": "Search",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.forgot-password": "Forgot Password",
  "menu.error": "Error",
  "menu.applications": "Applications",
  "menu.todo": "To-do List",
  "menu.survey": "Survey",
  "menu.chat": "Chat",
  "menu.ui": "UI",
  "menu.alerts": "Alerts",
  "menu.badges": "Badges",
  "menu.buttons": "Buttons",
  "menu.cards": "Cards",
  "menu.carousel": "Carousel",
  "menu.charts": "Charts",
  "menu.collapse": "Collapse",
  "menu.dropdowns": "Dropdowns",
  "menu.editors": "Editors",
  "menu.form-layouts": "Form Layouts",
  "menu.form-components": "Form Components",
  "menu.form-validations": "Form Validations",
  "menu.form-wizard": "Form Wizard",
  "menu.icons": "Icons",
  "menu.input-groups": "Input Groups",
  "menu.jumbotron": "Jumbotron",
  "menu.modal": "Modal",
  "menu.navigation": "Navigation",
  "menu.popover-tooltip": "Popover & Tooltip",
  "menu.sortable": "Sortable",
  "menu.tables": "Tables",
  "menu.menu": "Menu",
  "menu.subhidden": "Subhidden",
  "menu.hidden": "Hidden",
  "menu.visible": "Visible",
  "menu.maps": "Maps",
  "menu.landingpage": "Landing Page",
  "menu.multipage-home": "Multipage Home",
  "menu.singlepage-home": "Singlepage Home",
  "menu.about": "About",
  "menu.auth-login": "Auth Login",
  "menu.auth-register": "Auth Register",
  "menu.reset-password": "Reset Password",
  "menu.blog": "Blog",
  "menu.blog-list": "Blog List",
  "menu.blog-detail": "Blog Detail",
  "menu.careers": "Careers",
  "menu.confirmation": "Confirmation",
  "menu.docs": "Docs",
  "menu.features": "Features",
  "menu.prices": "Prices",
  "menu.videos": "Videos",
  "menu.mailing": "Mailing",
  "menu.invoice": "Invoice",
  "menu.blank-page": "Blank Page",
  "menu.types": "Menu Types",
  "menu.levels": "Menu Levels",
  "menu.third-level-1": "Third Level 1",
  "menu.third-level-2": "Third Level 2",
  "menu.third-level-3": "Third Level 3",
  "menu.faq": "Faq",
  "menu.knowledge-base": "Knowledge Base",
  "menu.authorization" : "Authorization",
  "menu.profile" : "Profile",
  "menu.product" : "Product",
  "menu.miscellaneous" : "Miscellaneous",
  "menu.portfolio": "Portfolio",
  "menu.social": "Social",
  "menu.details-alt": "Details Alt",
  "menu.forms": "Forms",
  "menu.components": "Components",
  "menu.layouts": "Layouts",
  "menu.validations": "Validations",
  "menu.wizard": "Wizard",
  
  /* 04.Dashboards */
  "dashboards.pending-orders": "Pending Orders",
  "dashboards.completed-orders": "Completed Orders",
  "dashboards.refund-requests": "Refund Requests",
  "dashboards.new-comments": "New Comments",
  "dashboards.sales": "Sales",
  "dashboards.orders": "Orders",
  "dashboards.refunds": "Refunds",
  "dashboards.recent-orders": "Recent Orders",
  "dashboards.product-categories": "Product Categories",
  "dashboards.cakes": "Cakes",
  "dashboards.tickets": "Tickets",
  "dashboards.calendar": "Calendar",
  "dashboards.best-sellers": "Best Sellers",
  "dashboards.website-visits": "Website Visits",
  "dashboards.unique-visitors": "Unique Visitors",
  "dashboards.this-week": "This Week",
  "dashboards.last-week": "Lat Week",
  "dashboards.this-month": "This Month",
  "dashboards.conversion-rates": "Conversion Rates",
  "dashboards.per-session": "Per Session",
  "dashboards.profile-status": "Profile Status",
  "dashboards.payment-status": "Payment Status",
  "dashboards.work-progress": "Work Progress",
  "dashboards.tasks-completed": "Tasks Completed",
  "dashboards.payments-done": "Payments Done",
  "dashboards.order-stock": "Order - Stock",
  "dashboards.categories": "Categories",
  "dashboards.quick-post": "Quick Post",
  "dashboards.title": "Title",
  "dashboards.content": "Content",
  "dashboards.category": "Category",
  "dashboards.save-and-publish": "Save and Publish",
  "dashboards.top-viewed-posts": "Top Viewed Posts",
  "dashboards.posts": "Posts",
  "dashboards.pending-for-publish": "Pending for publish",
  "dashboards.users": "Users",
  "dashboards.on-approval-process": "On approval process",
  "dashboards.alerts": "Alerts",
  "dashboards.waiting-for-notice": "Waiting for notice",
  "dashboards.files": "Files",
  "dashboards.pending-for-print": "Pending for print",
  "dashboards.logs": "Logs",
  "dashboards.gogo": "GOGO",
  "dashboards.magic-is-in-the-details": "MAGIC IS IN THE DETAILS",
  "dashboards.yes-it-is-indeed": "Yes, it is indeed!",
  "dashboards.advanced-search": "Advanced Search",
  "dashboards.toppings": "Toppings",
  "dashboards.type": "Type",
  "dashboards.keyword": "Keyword",
  "dashboards.search": "Search",
  "dashboards.top-rated-items": "Top Rated Items",

  /* 05.Pages */
  "pages.add-new": "ADD NEW",
  "pages.add-new-modal-title": "Add New Item",
  "pages.display-options": "Display Options",
  "pages.orderby": "Order By : ",
  "pages.product-name": "Product Name",
  "pages.category": "Category",
  "pages.description": "Description",
  "pages.status": "Status",
  "pages.cancel": "Cancel",
  "pages.submit": "Submit",
  "pages.delete": "Delete",
  "pages.another-action": "Another action",
  "pages.actions": "ACTIONS",
  "pages.header": "Header",
  "pages.details": "DETAILS",
  "pages.orders": "ORDERS",
  "pages.rating": "Rating",
  "pages.price": "Price",
  "pages.ingredients": "Ingredients",
  "pages.is-vegan": "Is Vegan",
  "pages.order-status": "Order Status",
  "pages.bake-progress": "Bake Progress",
  "pages.popularity": "Popularity",
  "pages.comments": "Comments",
  "pages.error-title": "Ooops... looks like an error occurred!",
  "pages.error-code": "Error code",
  "pages.go-back-home": "GO BACK HOME",
  "pages.mailing-info": "Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.",
  "pages.invoice-info": "Invoice template has an inline styled version for usage outside of the project as well as React version.",
  "pages.react-version": "React Version",
  "pages.inline-version": "Inline Styled Html Version",
  "pages.like": "Like",
  "pages.likes": "Likes",
  "pages.details-title": "Details",
  "pages.comments-title": "Comments",
  "pages.questions-title": "Questions",
  "pages.similar-projects": "Similar Projects",
  "pages.send": "Send",
  "pages.addComment": "Add a comment",
  "pages.location": "Location",
  "pages.responsibilities": "Responsibilities",
  "pages.photos": "Photos",
  "pages.who-to-follow": "Who to Follow",
  "pages.follow": "FOLLOW",
  "pages.followers": "FOLLOWERS",
  "pages.recent-posts": "Recent Posts",
  "pages.profile": "PROFILE",
  "pages.friends": "FRIENDS",
  "pages.images": "IMAGES",
  "pages.purchase": "PURCHASE",
  "pages.price.developer": "DEVELOPER",
  "pages.price.team": "TEAM",
  "pages.price.enterprise": "ENTERPRISE",
  "pages.price.twofactorauthentication": "Two factor authentication",
  "pages.price.teampermissions": "Team permissions",
  "pages.price.245Support": "24/5 Support",
  "pages.price.247Support": "24/7 Support",
  "pages.price.useractionsauditlog": "User actions audit log",
  "pages.prices.featurecomparison" : "Feature Comparison",
  "pages.prices.pricecomparison" : "Price Comparison",
  

  /* 06.Applications */

  /* 06.01.Chat */
  "chat.messages": "Messages",
  "chat.contacts": "Contacts",
  "chat.saysomething": "Say something..",


  /* 06.02.Survey */
  "survey.delete": "Delete",
  "survey.edit": "Edit",
  "survey.add-new": "ADD NEW",
  "survey.add-new-title": "Add New Survey",
  "survey.title": "Title",
  "survey.category": "Category",
  "survey.label": "Label",
  "survey.status": "Status",
  "survey.cancel": "Cancel",
  "survey.submit": "Submit",
  "survey.another-action": "Another action",
  "survey.display-options": "Display Options",
  "survey.orderby": "Order By : ",
  "survey.all-surveys": "All Surveys",
  "survey.completed-surveys": "Completed Surveys",
  "survey.categories": "Categories",
  "survey.active-surveys": "Active Surveys",
  "survey.labels": "Labels",

  /* 06.03.Todo */
  "todo.add-new": "ADD NEW",
  "todo.add-new-title": "Add New Todo",
  "todo.title": "Title",
  "todo.detail": "Detail",
  "todo.category": "Category",
  "todo.label": "Label",
  "todo.status": "Status",
  "todo.cancel": "Cancel",
  "todo.submit": "Submit",
  "todo.action": "Action",
  "todo.another-action": "Another action",
  "todo.display-options": "Display Options",
  "todo.orderby": "Order By : ",
  "todo.all-tasks": "All Tasks",
  "todo.pending-tasks": "Pending Tasks",
  "todo.completed-tasks": "Completed Tasks",
  "todo.categories": "Categories",
  "todo.labels": "Labels",

  /* 07.UI */

  /* 07.01.Alerts */
  "alert.rounded": "Rounded Alert",
  "alert.react-notifications": "React Notifications",
  "alert.outline": "Outline",
  "alert.primary": "Primary",
  "alert.secondary": "Secondary",
  "alert.info": "Info",
  "alert.success": "Success",
  "alert.warning": "Warning",
  "alert.error": "Error",
  "alert.filled": "Filled",
  "alert.primary-text": "This is a primary alert—check it out!",
  "alert.secondary-text": "This is a secondary alert—check it out!",
  "alert.success-text": "This is a success alert—check it out!",
  "alert.danger-text": "This is a danger alert—check it out!",
  "alert.warning-text": "This is a warning alert—check it out!",
  "alert.info-text": "This is a info alert—check it out!",
  "alert.light-text": "This is a light alert—check it out!",
  "alert.dark-text": "This is a dark alert—check it out!",
  "alert.default": "Default Alert",
  "alert.dismissing": "Dismissing Alert",
  "alert.dismissing-text":
    "Holy guacamole! You should check in on some of those fields below.",
  "alert.dismissing-without-animate-text":
    "I am an alert and I can be dismissed without animating!",

  /* 07.02.Badges */
  "badge.sizes": "Sizes",
  "badge.colors": "Colors",
  "badge.outline": "Outline",
  "badge.links": "Links",
  "badge.counter-badges": "Counter Badges",
  "badge.bootstrap-default": "Bootstrap Default",
  "badge.primary": "Primary",
  "badge.secondary": "Secondary",
  "badge.success": "Success",
  "badge.danger": "Danger",
  "badge.warning": "Warning",
  "badge.info": "Info",
  "badge.light": "Light",
  "badge.dark": "Dark",

  /* 07.03.Buttons */
  "button.default": "Bootstrap Default",
  "button.colors": "Colors",
  "button.rounded": "Rounded",
  "button.outline": "Outline",
  "button.states": "States",
  "button.sizes": "Sizes",
  "button.button-groups": "Button Groups",
  "button.large-button": "Large Button",
  "button.small-button": "Small Button",
  "button.extra-small-button": "Extra Small Button",
  "button.block-button": "Block Button",
  "button.active": "Active",
  "button.disabled": "Disabled",
  "button.basic": "Basic",
  "button.toolbar": "Toolbar",
  "button.nesting": "Nesting",
  "button.vertical-variation": "Vertical Variation",
  "button.checkbox-radio-button": "Checkbox and Radio Button",
  "button.checkbox": "Checkbox",
  "button.radio": "Radio",
  "button.radio-button": "Radio Button",
  "button.primary": "Primary",
  "button.secondary": "Secondary",
  "button.success": "Success",
  "button.danger": "Danger",
  "button.warning": "Warning",
  "button.info": "Info",
  "button.light": "Light",
  "button.dark": "Dark",
  "button.states-text":
    "This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.",
  "button.click-here": "Click Here",
  "button.states-text-alternate":
    "This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.",
  "button.primary-link": "Primary Link",
  "button.link": "Link",
  "button.primary-button": "Primary Button",
  "button.button": "Button",
  "button.left": "Left",
  "button.middle": "Middle",
  "button.right": "Right",
  "button.dropdown": "Dropdown",
  "button.dropdown-link": "Dropdown Link",

  /* 07.04.Cards */
  "cards.icon-card": "Icon Card",
  "cards.image-card": "Image Card",
  "cards.image-overlay-card": "Image Overlay Card",
  "cards.image-card-list": "Image Card List",
  "cards.tab-card": "Tab Card",
  "cards.user-card": "User Card",

  /* 07.05.Carousel */
  "carousel.basic": "Carousel Basic",
  "carousel.single": "Carousel Single",
  "carousel.without-controls": "Carousel Without Controls",

  /* 07.06.Charts */
  "charts.line": "Line Chart",
  "charts.polar": "Polar Chart",
  "charts.area": "Area Chart",
  "charts.scatter": "Scatter Chart",
  "charts.bar": "Bar Chart",
  "charts.radar": "Radar Chart",
  "charts.pie": "Pie Chart",
  "charts.doughnut": "Doughnut Chart",
  "charts.shadow": "Shadow",
  "charts.no-shadow": "No Shadow",

  /* 07.07.Collapse */
  "collapse.basic": "Basic",
  "collapse.toggle": "Toggle",
  "collapse.accordion": "Accordion",
  "collapse.controlled": "Controlled",
  "collapse.uncontrolled": "Uncontrolled",

  /* 07.08.Dropdowns */
  "dropdowns.basic": "Basic",
  "dropdowns.controlled": "Controlled",
  "dropdowns.uncontrolled": "Uncontrolled",
  "dropdowns.dropdown": "Dropdown",
  "dropdowns.header": "Header",
  "dropdowns.action": "Action",
  "dropdowns.another-action": "Another Action",
  "dropdowns.right": "Right",
  "dropdowns.left": "Left",
  "dropdowns.drop-directions": "Drop Directions",
  "dropdowns.dropright": "Dropright",
  "dropdowns.dropleft": "Dropleft",
  "dropdowns.small-button": "Small Button",
  "dropdowns.large-button": "Large Button",
  "dropdowns.sizing": "Sizing",
  "dropdowns.split-button": "Split Button Dropdowns",
  "dropdowns.dropup": "Dropup",

  /* 07.09.Editors */
  "editors.draftjs": "Draft.js",
  "editors.quill-standart": "Quill Standard",
  "editors.quill-bubble": "Quill Bubble",

  /* 07.10.Forms */
  "forms.basic": "Basic",
  "forms.email": "E-mail",
  "forms.email-muted": "We'll never share your email with anyone else.",
  "forms.password": "Password",
  "forms.password-confirm": "Confirm Password",
  "forms.submit": "Submit",
  "forms.horizontal": "Horizontal",
  "forms.radios": "Radios",
  "forms.first-radio": "First radio",
  "forms.second-radio": "Second radio",
  "forms.third-radio-disabled": "Third disabled radio",
  "forms.checkbox": "Checkbox",
  "forms.signin": "Sign in",
  "forms.top-labels-over-line": "Top Labels Over Line",
  "forms.tags": "Tags",
  "forms.date": "Date",
  "forms.state": "State",
  "forms.top-labels-in-input": "Top Labels In Input",
  "forms.email-u": "E-MAIL",
  "forms.password-u": "PASSWORD",
  "forms.tags-u": "TAGS",
  "forms.date-u": "DATE",
  "forms.state-u": "STATE",
  "forms.grid": "Form Grid",
  "forms.address": "Address",
  "forms.address2": "Address 2",
  "forms.city": "City",
  "forms.city-message": "Please select a city!",
  "forms.state-message": "Please select a state!",
  "forms.zip": "Zip",
  "forms.signup": "Signup",
  "forms.inline": "Inline",
  "forms.validation-availity": "Availity Reactstrap Validation",
  "forms.validation-formik": "Formik Validation",
  "forms.default": "Default",
  "forms.firstname": "First name",
  "forms.firstname-message": "Please enter your first name!",
  "forms.lastname": "Last name",
  "forms.lastname-message": "Please enter your last name!",
  "forms.name": "Name",


  /* 07.11.Form Components */
  "form-components.custom-inputs": "Custom Inputs",
  "form-components.checkboxes": "Checkboxes",
  "form-components.radios": "Radios",
  "form-components.inline": "Inline",
  "form-components.react-select": "React Select",
  "form-components.state-single": "State Single",
  "form-components.state-multiple": "State Multiple",
  "form-components.react-autosuggest": "React Autosuggest",
  "form-components.date-picker": "Date Picker",
  "form-components.date": "Date",
  "form-components.date-range": "Date Range",
  "form-components.date-with-time": "Date with Time",
  "form-components.embedded": "Embedded",
  "form-components.dropzone": "Dropzone",
  "form-components.drop-files-here": "Drop Files Here",
  "form-components.tags": "Tags",
  "form-components.switch": "Switch",
  "form-components.primary": "Primary",
  "form-components.secondary": "Secondary",
  "form-components.primary-inverse": "Primary Inverse",
  "form-components.secondary-inverse": "Secondary Inverse",
  "form-components.slider": "Slider",
  "form-components.double-slider": "Double Slider",
  "form-components.single-slider": "Single Slider",
  "form-components.rating": "Rating",
  "form-components.interactive": "Interactive",
  "form-components.readonly": "Readonly",
  "form-components.type-a-cake": "Type a Cake",
  "form-components.start": "Start",
  "form-components.end": "End",
  "form-components.tables": "Tables",
  /* 07.12.Icons */
  "icons.simplelineicons": "Simple Line Icons",
  "icons.iconsmind": "Iconsmind Icons",

  /* 07.13.Input Groups */
  "input-groups.basic": "Basic",
  "input-groups.sizing": "Sizing",
  "input-groups.small": "Small",
  "input-groups.default": "Default",
  "input-groups.large": "Large",
  "input-groups.checkboxes-and-radios": "Checkboxes and radios",
  "input-groups.multiple-inputs": "Multiple Inputs",
  "input-groups.first-and-last-name": "First and last name",
  "input-groups.multiple-addons": "Multiple Addons",
  "input-groups.button-addons": "Button Addons",
  "input-groups.button": "Button",
  "input-groups.buttons-with-dropdowns": "Buttons with Dropdowns",
  "input-groups.dropdown": "Dropdown",
  "input-groups.header": "Header",
  "input-groups.action": "Action",
  "input-groups.another-action": "Another Action",
  "input-groups.custom-select": "Custom Select",
  "input-groups.options": "Options",
  "input-groups.choose": "Choose...",
  "input-groups.custom-file-input": "Custom File Input",

  /* 07.14.Jumbotron */
  "jumbotron.hello-world": "Hello, world!",
  "jumbotron.lead":
    "This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.",
  "jumbotron.lead-detail":
    "It uses utility classes for typography and spacing to space content out within the larger container.",
  "jumbotron.learn-more": "Learn more",

  /* 07.15.Modal */
  "modal.basic": "Basic",
  "modal.modal-title": "Modal title",
  "modal.launch-demo-modal": "Launch Demo Modal",
  "modal.scrolling-long-content": "Scrolling Long Content",
  "modal.backdrop": "Backdrop",
  "modal.backdrop-value": "Backdrop value",
  "modal.right-modal": "Right Modal",
  "modal.launch-right-modal": "Launch Right Modal",
  "modal.nested-modal": "Nested Modal",
  "modal.size": "Size",
  "modal.launch-large-modal": "Launch Large Modal",
  "modal.launch-small-modal": "Launch Small Modal",

  /* 07.16.Navigation */
  "nav.basic": "Nav Basic",
  "nav.active": "Active",
  "nav.disabled": "Disabled",
  "nav.disabled-link": "Disabled Link",
  "nav.link": "Link",
  "nav.longer-link": "Longer nav link",
  "nav.another-link": "Another Link",
  "nav.right": "Right",
  "nav.dropdown": "Dropdown",
  "nav.header": "Header",
  "nav.action": "Action",
  "nav.another-action": "Another Action",
  "nav.horizontal-alignment": "Nav Horizontal Alignment",
  "nav.vertical-alignment": "Nav Vertical Alignment",
  "nav.pills": "Nav Pills",
  "nav.fill-justify": "Nav Fill and Justify",
  "nav.pills-dropdowns": "Nav Pills with Dropdowns",
  "nav.pagination-basic": "Pagination Basic",
  "nav.pagination-sizing": "Pagination Sizing",
  "nav.large": "Large",
  "nav.small": "Small",
  "nav.center": "Center",
  "nav.pagination-alignment": "Pagination Alignment",
  "nav.breadcrumb-basic": "Breadcrumb Basic",

  /* 07.17.Popover & Tooltip */
  "popover-tooltip.popover": "Popover",
  "popover-tooltip.tooltip": "Tooltip",

  /* 07.18.Sortable */
  "sortable.columns": "Sorting Columns",
  "sortable.basic": "Basic",
  "sortable.handles": "Handles",

  /* 07.19.Maps */
  "maps.google": "Google",
  "maps.yandex": "Yandex",

  /* 07.20.Tables */
  "table.bootstrap-tables": "Bootstrap Tables",
  "table.bootstrap-basic": "Basic Table",
  "table.bootstrap-striped": "Striped Rows",
  "table.bootstrap-bordered": "Bordered Table",
  "table.bootstrap-borderless": "Borderless Table",
  "table.bootstrap-hoverable": "Hoverable Rows",
  "table.bootstrap-responsive": "Responsive Table",
  "table.react-tables": "React Tables",
  "table.react-pagination": "Pagination",
  "table.react-scrollable": "Scrollable",
  "table.react-advanced": "Filter, Length and Jump",

   /* 07.21.Wizards */
   "wizard.step-name-1": "Step 1",
   "wizard.step-name-2": "Step 2",
   "wizard.step-name-3": "Step 3",
   "wizard.step-desc-1": "First step description",
   "wizard.step-desc-2": "Second step description",
   "wizard.step-desc-3": "Third step description",
   "wizard.content-1": "Step content for first step.",
   "wizard.content-2": "Step content for second step.",
   "wizard.content-3": "Last step content!",
   "wizard.content-thanks": "Thank You!",
   "wizard.next": "Next",
   "wizard.prev": "Back",
   "wizard.registered": "Your registration completed successfully!",
   "wizard.async": "Async save for 3 seconds!",

  //Category
  "menu.category": "Category",
  /* 01.General */
  "user.not-member": "If you are not a member, please",
  "user.authError": "Invalid Credentials",
  "forgotPasswordQuestion": "Forgot Password?",


  ///////////////////CLIENTS/////////////////
  "menu.clients": "Clients",
  "client.address1": "Street Name & #",
  "client.address2": "Name Of City",
  "client.country": "Country",
  "client.address3": "Postal Code",
  "client.company": "Company",
  "client.company-type": "Company Type",
  "client.company-sector": "Company Sector",
  "client.create":"Create Client",
  "client.name":"Name",
  "client.gender":"Gender",
  "client.first-name":"First Name",
  "client.last-name":"Last Name",
  "client.email":"Email",
  "client.phone":"Phone",
  "client.save":"Create Client",
  "client.view":"Clients",
  "client.enable": "Activate",
  "client.disable": "Deactivate",
  "client.delete": "Delete",
  "client.edit": "Edit",
  "client.update": "Update",
  /////
  "menu.client-types": "Company Types",
  "menu.type": "Types",
  "client.client-types": "Company Types",
  "client-types.create": "Create",
  "client-types.edit": "Edit",
  "client-types.update": "Update",
  "client-types.view": "View",
  "client-types.delete": "Delete",
  "client-types.create-type-create": "Create Client Company Type",
  "client-types.create-type-view": "Client Company Types",
  "client-types.create-type-update": "Update Client Company Type",
  ////
  "menu.client-sector": "Company Sector",
  "menu.sector": "Sectors",
  "client.client-sector": "Company Sectors",
  "client-sector.create": "Create",
  "client-sector.edit": "Edit",
  "client-sector.update": "Update",
  "client-sector.view": "View",
  "client-sector.delete": "Delete",
  "client-sector.create-sector-create": "Create Client Company Sector",
  "client-sector.create-sector-view": "Client Company Sectors",
  "client-sector.create-sector-update": "Update Client Company Sector",
// Dashboard
  "dashboards.recent-missions": "Recent Missions",
  'dashboards.new-events': "New Events",
  "dashboard.apply-missions": "Apply",
  //////////////MISSIONS////////////////
  //mission
  "menu.missions": "Missions",
  "menu.single-missions": "Mission",
  "menu.mission": "Missions",
  "mission.create": "Create",
  "mission.view": "View",
  "mission.jeh-of-student": "JEH of Student",
  "mission.jeh-of-leader": "JEH of Project Leader",
  "mission.is-leader-paid": "Is Project Leader Paid?",
  "mission.applications": "Mission Applications",
  "mission.application": "Mission Application",
  "mission.application-view": "View Applications",
  "mission.applications-view": "View",
  "mission.application-assign": "Assign Students",
  "mission.create-mission": "Create Mission",
  "mission.update-mission": "Update Mission",
  "mission.update": "Update",
  "mission.edit": "Edit",
  "mission.delete": "Delete",
  "mission.client": "Client",
  "mission.leader": "Leader",
  "mission.name": "Name",
  "mission.description": "Description",
  "mission.deadline": "Deadline",
  "mission.project-cost": "Project Cost",
  "mission.sub-categories": "Sub Categories",
  "mission.phases": "Phases",
  "mission.tasks": "Tasks",
  "mission.add-tasks": "Add Task",
  "mission.phase-remove": "Remove",
  "mission.phase-add": "Add Phase",
  "mission.phase-name": "Name",
  "mission.phase-deadline": "Deadline",
  "mission.phase-working-days": "Working Days",
  "mission.phase-description": "Description",
  "mission.intervening-students": "Intervening Students",
  "missions.view": "View",
  "mission.missions": "Missions",
  "mission.apply": "Apply",
  "mission.apply-mission": "Apply Mission",
  "mission.cover-letter": "Cover Letter",
  "mission.tasks-file": "File",
  "mission.status-change": "Change Mission Status",
  "mission.status-change-b": "Change Status",
  "mission.select-status": "Select Mission Status",
  "mission.surveys": "Mission Surveys",
  "mission.received-by": "Mission Received By",
  //FE TAB
  "menu.fe-tab": "FE",
  "menu.fe-tab-view": "View",
  //FE TAB
  "menu.ndf-tab": "NDF",
  "ndf.ndf-tab-name": "Note De Faris",
  "menu.fe-ndf-view": "View",
  //BV Tab
  "menu.bv-tab": "BV",
  "bv.bv-tab-name": "Bulletin De Versement",
  "menu.bv-tab-view": "View",
  //FAC Tab
  "menu.fac-tab": "FAC",
  "menu.facture": "View",
  "fac.fac-tab-name": "Facture",
  "menu.fac-tab-view": "View",
  //Create FAC
  "menu.fac-create": "Generate FAC",
  "menu.fac-generate": "Generate",
  "fac.reason-of-expense": "Reason Of Expense",
  "fac.facture-documents": "Facture Documents",
  "fac.facture-uploaded-documents": "Facture Uploaded Documents",
  "fac.generate": "Generate",
  "fac.add-expense": "Add Expense",
  "fac.expenses": "Expenses",
  "menu.fac-edit": "Edit",
  "menu.fac-update": "Update FAC",
  "fac.update": "update",
  //FeedBack
  "mission.feedback-menu": "Mission Feedback",
  "mission.feedback": "Feedback",
  "mission.feedback-feedback": "Mission Feedback",
  "mission.feedback-ratings": "Mission Rating",
  "mission.feedback-select-mission": "Select Mission",
  "mission.feedback-select-student": "Select Student",
  "mission.feed-save": "Send",
  //Categories
  "menu.categories": "Categories",
  "mission-categories": "Categories",
  "categories-create": "Create",
  "button-categories-create": "Create Category",
  "mission-categories-create": "Create Category",
  "categories-view": "View",
  "mission-missions": "Missions",
  "mission-category.delete": "Delete",
  "mission-category.edit": "Edit",
  "mission-category.update": "Update Category",
  //Subcategories
  "menu.sub-categories": "Sub Categories",
  "mission-sub-categories": "Sub Categories",
  "sub-categories-create": "Create",
  "button-sub-categories-create": "Create Sub Category",
  "mission-sub-categories-create": "Create Sub Category",
  "sub-categories-view": "View",
  "mission-sub-category.delete": "Delete",
  "mission-sub-category.edit": "Edit",
  "mission-sub-category.name": "Name",
  "mission-sub-category.update": "Update Sub Category",
  "mission-sub-category-parent": "Parent Category",
  //Intervening Students
  "menu.intervening-students": "Intervening Students",
  "menu.student": "Intervening Students",
  //Subjects
  "menu.students": "Intervening Students",
  "menu.subjects":"Subjects",
  "subject.create":"create",
  "subject.name":"Name",
  "subject.division":"Division",
  "subject.create-subject":"Create Subject",
  "subject.view":"View",
  "subject.view-subjects":"Subjects",
  "subject.edit":"Edit",
  "subject.update":"Update",
  "subject.delete":"Delete",
  "subject.update-subject":"Update Subject",
  //Profile
  "menu.leaders": "Leaders",
  "menu.webmasters": "Webmasters",
  //Leaves
  "menu.leaves": "Leaves",
  "leave.create": "Create",
  "leave.create-leave": "Create Leave",
  "leave.reason": "Reason",
  "leave.start-date": "Start Date",
  "leave.end-date": "End Date",
  "leave.view": "View",
  "leave.leaves": "Leaves",
  "leave.edit": "Edit",
  "leave.update": "Update",
  "leave.update-leave": "Update Leave",
  "leave.delete": "Delete",
  //Roles
  "menu.roles": "Roles",
  "roles.role-name": "Name",
  "roles.create":"Create",
  "roles.edit":"Edit",
  "roles.update":"Update",
  "roles.views":"View",
  "roles.create-role":"Create Role",
  "roles.update-role":"Update Role",
  "roles.view-roles":"Roles",
  "roles.name":"Roles",
  "role.permissions":"Permissions",
  "role.view-permissions":"View",
  "role.close-permissions-modal":"Close",
  //Users
  "menu.users": "Users",
  "user.create": "Create",
  "user.create-user": "Create User",
  "user.first-name": "First Name",
  "user.last-name": "Last Name",
  "user.gender": "Gender",
  "user.type": "User Type",
  "user.city": "City",
  "user.address": "Address",
  "user.nationality": "Nationality",
  "user.visa-number": "Visa Number",
  "user.registration-date": "Registration Date",
  "user.country": "Country",
  "user.phone": "Phone",
  "user.dob": "Date of Birth",
  "user.user-email": "Email",
  "user.user-password": "Password",
  "user.confirm-password": "Confirm Password",
  "user.roles": "Roles",
  "user.update-roles": "Update",
  "user.change-roles": "Change Roles",
  "user.view-roles": "View Roles",
  "user.view": "View",
  "user.users": "Users",
  //Xprojets Life
  "menu.xprojets-life": "XProjets Life",
  //Articles
  "xprojets-life.articles": "Articles",
  "menu.articles": "Articles",
  "menu.article-detail": "Article Details",
  "articles.create": "Create",
  "articles.create-article": "Create Article",
  "articles.view": "View",
  "articles.status": "Status",
  "articles.edit": "Edit",
  "articles.update": "Update",
  "articles.update-article": "Update Article",
  "articles.delete": "Delete",
  "articles.title": "Title",
  "articles.content": "Content",
  "articles.image": "Image",
  //Notes
  "xprojets-life.notes": "Notes",
  "menu.notes": "Notes",
  "notes.create": "Create",
  "notes.create-note": "Create Note",
  "notes.view": "View",
  "notes.edit": "Edit",
  "notes.details": "Details",
  "notes.update": "Update",
  "notes.update-note": "Update Note",
  "notes.delete": "Delete",
  "notes.title": "Title",
  "notes.status": "Status",
  "notes.content": "Content",
  "notes.image": "Image",
  "notes.docs": "Documents",
  "notes.short-description": "Short Description",
  //Articles
  "xprojets-life.news": "News",
  "menu.news": "News",
  "news.create": "Create",
  "news.create-news": "Create Articles",
  "news.view": "View",
  "news.edit": "Edit",
  "news.details": "Details",
  "news.update": "Update",
  "news.update-note": "Update Articles",
  "news.delete": "Delete",
  "news.title": "Title",
  "news.content": "Content",
  "news.image": "Image",
  //Good Intervening Students
  "good-student.menu": "How To Be a Good Intervening Student?",
  "good-student.create-good": "How to be a good intervening student?",
  "good-student.create": "Create",
  "good-student.content": "Content",
  "good-student.save": "Save",
  //Survey Questions
  "survey.select-survey": "Select Survey",
  "menu.questions": "Questions",
  "survey.question-menu": "Questions",
  "survey.question-questions": "Questions",
  "survey.create-question": "Create Question",
  "survey.create-create": "Create",
  "survey.question-edit": "Edit",
  "survey.question-delete": "Delete",
  "survey.add-question": "Add Question",
  "survey.question": "Question",
  "survey.question-title": "Title",
  "survey.answer-type": "Answer Type",
  "survey.question-update-question": "Update Question",
  "survey.question-update": "Update",
  "survey.answer-type-checkbox": "Checkbox",
  "survey.answer-type-radio": "Radiobutton",
  "survey.answer-type-textarea": "Text Area",
  "survey.question-answers": "Answers",
  "survey.question-add-answer": "Add Answers",
  "menu.survey-view": "View Survey",

  //Permissions
  "menu.permissions": "Permissions",
  "permission.permissions": "Permissions",
  "permission.name": "Name",
  "permission.categories": "Categories",
  "permission.subcategories": "Sub Categories",
  "permission.missions": "Missions",
  "permission.create": "Create",
  "permission.view": "View",
  "permission.update": "Update",
  "permission.edit": "Edit",
  "permission.update-permission": "Update Permission",
  "permission.status": "Status",
  //Events
  "dashboards.events": "Events",
  "menu.events": "Events",
  "menu.event": "Event",
  "event.create":"Create",
  "event.create-event":"Create Event",
  "event.edit":"Edit",
  "event.update":"Update",
  "event.update.event":"Update Event",
  "event.delete":"delete",
  "event.view":"View",
  "event.bookings":"Bookings",
  "event.event-bookings":"Event Bookings",
  "event.event-booking-close":"Close",
  "event.view-events":"Events",
  "event.division":"Division",
  "event.name":"Name",
  "event.description":"Description",
  "event.image":"Image",
  "event.type":"Type",
  "event.status":"Status",
  "event.booking-start-date":"Booking Start Date",
  "event.last-booking-date":"Last Booking Date",
  "event.start-date":"Event Start Date",
  "event.end-date":"Event End Date",
  "event.location":"Location",
  "event.price":"Price",
  "event.discounted-tickets":"Discounted Tickets",
  "event.total-tickets":"Total Tickets",
  //Divisions
  "menu.divisions": "Divisions",
  "event.divisions-menu": "Divisions",
  "event.divisions-divisions": "Divisions",
  "event.division-create": "Create",
  "event.divisions-create-division": "Create Division",
  "event.division-name": "Name",
  "event.division-view": "View",
  "event.division-edit": "Edit",
  "event.division-update": "Update",
  "event.division-delete": "Delete",
  "event.division-update-division": "Update Division",
  "event.divisions-members":"Division Members",
  "event.divisions-view-members":"View Members",
  "event.divisions-close-members-modal":"Close",
  "event.divisions-add-members":"Add Members",
  "event.divisions-remove-members":"Remove",
  "event.discussion":"Discussion",
  "menu.settings": "Settings",
  "settings.general-settings": "General Settings",
  "settings.general": "General",
  "menu.general": "General",
  "menu.general-settings": "General Settings",
  "settings.treasure-inputs": "Treasure Inputs",
  "settings.mission-auto-assign": "Mission Auto Assign",
  "menu.treasure-inputs": "Treasure Inputs",
  "treasure-base": "Base URSSAF",
  "treasure-sante-junior": "SANTE Part Junior",
  "treasure-etudiant": "SANTE Part Etudiant",
  "treasure-accident": "ACCIDENT DU TRAVAIL Part Junior",
  "treasure-retraite-junior": "Retraite Sécurité Sociale plafonnée TA Part Junior",
  "treasure-retraite-etudiant": "Retraite Sécurité Sociale plafonnée TA Part Etudiant",
  "treasure-famille": "Famille Part Junior",
  "treasure-assurance": "Assurance chômage Part Etudiant",
  "treasure-assurance-chomage": "Assurance chômage Part Junior",
  "treasure-AUTRES-CONTRIBUTIONS": "AUTRES CONTRIBUTIONS DUES PAR LA JUNIOR Part Junior",
  "treasure-CSG-deductible": "CSG déductible de l'impôt sur le revenu Part Etudiant",
  "treasure-CSG-CRDS-deductible": "CSG/CRDS non déductibles de l'impôt sur le revenu Part Etudiant",
  "treasure-siret-number": "Siret number",
  "treasure-code-ape": "Code APE number",
  "treasure-intra-number": "N° TVA intra number",
  "treasure-rib-number": "RIB number",
  "treasure-domiciliation": "Domiciliation",
  "treasure-iban": "IBAN",
  "treasure-bic": "BIC",
  "treasure-president": "President",
  "treasure-vice-president": "Vice President",
  "treasure-treasurer": "Treasurer",
  "treasure-vice-treasurer": "Vice Treasurer",
  "treasure-general-secretary": "General secretary",
  "treasurer": "Treasurer",
  "menu.treasurer": "Treasurer",
//Intervening Students Profile
  "menu.students-profile": "My Profile",
  "menu.profile-details": "Profile Details",
  "menu.profile-edit": "Edit Profile",
  "student.name": "Name",
  "student.about": "About",
  "student.profile-picture": "Profile Picture",
  "student.interests": "Interests",
  "student.subjects": "Subjects",
  "student.dob": "Date of Birth",
  "student.phone": "Phone",
  "student.update-profile": "Update Profile",
  "preferredLanguage": "Preferred Language",
  /////////////Lang SETTINGS/////////////////////////////
  "menu.language": "Languages",
  "menu.languages": "Languages",
  "language.create": "Create",
  "language.create-language": "Create Language",
  "language.abbreviation": "Abbreviation",
  "language.locale": "Locale",
  "language.name": "Name",
  "timeline": "Timeline",
  "language.image": "Image",
  "language.active": "Active",
  "language.native-name": "Native Name",
  "language.edit": "Edit",
  "language.view": "View",
  "language.languages": "Languages",
  "language.update": "Update",
  "language.update-language": "Update Language",
  "language.delete": "Delete",
  "language.key-value": "Languages Translations",
  "menu.key-value": "Translations",
  "menu.timeline": "Timeline",

  //Sections
  "menu.section":"Section",
  "menu.sections":"Sections",
  "sections.create":"Create",
  "sections.sync":"Sync",
  "sections.create-section":"Create Section",
  "sections.name":"Name",
  "sections.edit":"Edit",
  "sections.update":"Update",
  "sections.update-section":"Update Section",
  "sections.close":"Close",
  //Keys
  "menu.keys":"Keys",
  "menu.Key":"Keys",
  "key.create":"Create",
  "keys.create-keys":"Create Key",
  "key.name":"Name",
  "key.key":"Key",
  "key.edit":"Edit",
  "key.section":"Section",
  "key.update":"Update",
  "key.update-key":"Update Key",
  "key.close":"Close",
  //MoneyFlow
  "menu.money-flow": "Money Flow",
  "money-flow.money-flow": "Money Flow",
  "money-flow.view": "View",
  "money-flow.edit": "Edit",
  "money-flow.delete": "Delete",
  "money-flow.create": "Create",
  "money-flow-menu.create": "Create",
  "money-flow-menu.view": "View",
  "money-flow.update": "Update",
  "money-flow.create-money-flow": "Create Money Flow",
  "money-flow.update-money-flow": "Update Money Flow",
  "money-flow.project": "Project",
  "money-flow.event": "Event",
  "money-flow.flow": "Flow",
  "money-flow.amount": "Amount",
  "money-flow.details": "Details",
  //Money Request///
  "menu.money-request": "Money Request",
  "menu.money-requests": "View",
  "money-request.money-request-for": "Request For",
  "money-request.mission": "Select Mission",
  "money-request.event": "Select Event",
  "money-request.money-requests-view": "View",
  "money-request.money-requests": "Money Requests",
  "money-request.withdraw": "Withdraw",
  "money-request.send": "Send",
  "money-request.request": "Send",
  "money-request.change": "Change",
  "money-request.send-money-request": "Send Money Request",
  "money-request.change-money-request": "Change Money Request",
  "money-request.reason": "Reason",
  "money-request.support-documents": "Documents to Support Reason",
  "money-request.first-name": "First Name",
  "money-request.last-name": "Last Name",
  "money-request.req-date": "Request Date",
  "money-request.req-description": "Request Description",
  "money-request.designation": "Designation",
  "money-request.amount": "Amount",
  "money-request.tva": "TVA",
  "money-request.ttc": "TTC",
  "money-request.add-row": "Add Row",
  "money-request.rows": "Rows",
  //Students document Upload
  "document.upload-document-text": "Please upload the following documents ",
  "document.upload-document-pdf": "Only PDF Files & Images are allowed to be uploaded",
  "document.id": "Your ID",
  "document.student-card": "Student Card",
  "document.health-card": "Healthcare Card",
  "document.CVEC": "CVEC Attestation",
  "document.bank-rib": "Bank RIB",
  "document.registration-form": "Registration Form",
  "document.registration-convention": "Registration Convention",
  "document.upload": "Upload",
  "document.upload-documents": "Upload Documents",
  //Student Registration
  "student.first-name": "First Name",
  "student.last-name": "Last Name",
  "student.gender":"Gender",
  "student.email":"Email",
  "student.registration-date":"Registration Date",
  "student.date-of-birth":"Date of Birth",
  "student.type":"Student Type",
  "student.place-of-birth":"Place of birth",
  "student.city":"City",
  "student.country":"Country",
  "student.nationality":"Nationality",
  "student.visa-number":"Visa Number",
  "student.password":"Password",
  "student.confirm-password":"Confirm Password",
  "student.phone-number":"Phone Number",
  "student.already-member":"Already member? please",
  "student.curriculum":"Curriculum",
  "student.postalCode":"Postal Code",
  "resendEmail": "Resend Email",
  "wizard.notEmailReceived": "Didn't Receive Email?",
  "menu.newsletter": "Newsletter",
  "menu.tags": "Tags",
  "tag.edit": "Edit",
  "tag.view": "View",
  "seo-tag.view": "View",
  "tag.update": "Update",
  "menu.seo-tags": "Seo Tags",
  "menu.posts": "Posts",
  "menu.authors": "Authors",
  "menu.author": "Authors",
  "menu.post": "Posts",
  "menu.quotes": "Quotes",
  "menu.quote": "Quotes",

};
